module.exports = __webpack_public_path__ + "static/img/200122.1442f9ee.png";